import type { TDynamicOrderData, TStaticInitialOrderData } from "../../types";
import useUpdateCountriesTo from "./dynamicData/useUpdateCountriesTo";
import useUpdateOffers, { TUpdateOffersParams } from "./dynamicData/useUpdateOffers";
import useUpdatePackageSizes from "./dynamicData/useUpdatePackageSizes";
import useUpdatePickupTimeFrames, { TUpdatePickupTimeFramesParams } from "./dynamicData/useUpdatePickupTimeFrames";

type TDynamicDataReturns = {
  dynamicData: TDynamicOrderData;
  updateCountriesTo: (countryFrom?: string) => void;
  updatePackageSizes: (countryFrom?: string, countryTo?: string, deliveryMethod?: string) => void;
  updateOffers: (params: TUpdateOffersParams) => void;
  updatePickupTimeFrames: (params: TUpdatePickupTimeFramesParams) => void;
};

const useDynamicData = (staticOrderData?: TStaticInitialOrderData): TDynamicDataReturns => {
  const { countriesTo, updateCountriesTo } = useUpdateCountriesTo(staticOrderData?.countriesTo || []);

  const { packageSizes, updatePackageSizes } = useUpdatePackageSizes(staticOrderData?.packageSizes || []);

  const { offers, coupon, errorMessage, fieldErrors, marketingConsent, updateOffers } = useUpdateOffers(staticOrderData?.offers || [], staticOrderData?.isPaymentFailed || false);
  const { pickupTimeFrames, updatePickupTimeFrames } = useUpdatePickupTimeFrames();

  const dynamicData = {
    countriesTo,
    packageSizes,
    offers,
    pickupTimeFrames,
    coupon,
    errorMessage,
    fieldErrors,
    marketingConsent
  };

  return { dynamicData, updateCountriesTo, updatePackageSizes, updateOffers, updatePickupTimeFrames };
};
export default useDynamicData;
